import { DomainError } from '@dma/shared';

/**
 * Raised when a sign-in attempt is rejected (wrong email/password, or an
 * account that does not exist). Deliberately generic per
 * docs/architecture/02-security-architecture.md — never reveals whether the
 * email or the password was the specific problem, to avoid user enumeration.
 */
export class AuthenticationFailedError extends DomainError {
  constructor(options?: { cause?: unknown }) {
    super('AUTH_INVALID_CREDENTIALS', 'ایمیل یا رمز عبور اشتباه است.', options);
    this.name = 'AuthenticationFailedError';
    Object.setPrototypeOf(this, AuthenticationFailedError.prototype);
  }
}
